<breadcrumb-navigation [titles]="[{ key: 'HOME_ECATALOG' | translate, url: '/ecatalog'},{ key: 'VIN_SEARCH' | translate, url: ''}]" [needHome]="false"></breadcrumb-navigation>
<div class="mobile-vin-search drawer-body" (click)="isSearchSuccess = false">
  <div class="search-input">
    <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input_mobile">
      <input 
        nz-input 
        type="text" 
        [(ngModel)]="vinSearchValue"
        [maxLength]="17"
        [placeholder]="'SEARCH_BY_VIN_NUMBER' | translate" 
      />
      <ng-template #suffixTemplateInfo>
        <span nz-icon style="color: #595E62;" nzType="close" nzTheme="outline" [hidden]="vinSearchValue === ''" (click)="clearVehiclesVin()" ></span>
        <svg-icon [iconName]="'new/ui-ic-search-blue.svg'" (click)="queryVehiclesByVin()"></svg-icon>
      </ng-template>
    </nz-input-group>
    <div class="search-input__result" [hidden]="isSearchSuccess && vinSearchResults.length === 0">
      <div class="search-input__result-item" *ngFor="let item of vinSearchResults;">
        <label size="small" nz-checkbox [(ngModel)]="item.checked" class="items-center">{{ item.carName }}</label>
      </div>
    </div>
    <div class="search-input__result" *ngIf="isSearchSuccess && vinSearchResults.length === 0">
      <div class="search-input__result-item">
        {{ 'NO_RESULTS_FOUND' | translate }}
      </div>
    </div>
  </div>
  <div class="search-storage" >
    <div class="search-storage__title">
      <span>{{'SEARCH_HISTORY'|translate}}</span>
      <svg-icon [iconName]="'new/delete.svg'" (click)="handleClearSearchStorage()"></svg-icon>
    </div>
    <div class="search-storage__vin-list">
      <div class="search-storage__vin-item" *ngFor="let vin of storageVinList;" (click)="handleChooseStorage(vin)">{{ vin }}</div>
    </div>
  </div>

  <div class="fixed-button">
    <div class="confirm-button" (click)="handleSubmitNext()">
      <span class="pr-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path d="M22.2071 11.9999L17.8536 16.3535L17.1464 15.6464L20.2929 12.4999H2.5V11.4999H20.2929L17.1464 8.35352L17.8536 7.64636L22.2071 11.9999Z" fill="white"/>
          </svg>
      </span>
      {{'NEXT_STEP' | translate }}
    </div>
  </div>
</div>